const AppEnv = {
  urlBack: process.env.REACT_APP_URL_BACK as string,
  timeout: process.env.REACT_APP_TIMEOUT as string,
  withMocks: process.env.REACT_APP_ENABLE_MOCKS as string,
  typeAuth: process.env.REACT_APP_TYPE_AUTH as string,
};

export default AppEnv;
